module.exports = __webpack_public_path__ + "static/siemenslogo-7b64c77cf7d45e070a2cbdc4eeb311b6.svg";